import { trackEvent } from "../utils/track-event";
import type {
  TrackingEvent,
  TrackingEventResponse,
  TrackPromotionProps,
} from "../utils/types";

type ClickedPromotionEventProps = TrackPromotionProps & {
  tab?: string;
  gatedActionType?: string;
  shopType?: string;
  redirectTo?: string;
};

export type ClickPromotionEvent = TrackingEvent<
  "Click Promotion",
  {
    promo_id?: string;
    promo_creative?: string;
    promo_position?: string;
    promo_type?: string;
    promo_display_type?: string;
    promo_path?: string;
    shop_type?: string;
    redirect_to?: string;
    gated_action_type?: string;
    tab?: string;
    gated: boolean;
  }
>;

export async function trackClickedPromotionEvent({
  id,
  name,
  creative,
  position,
  tab,
  promotionType,
  promoDisplayType,
  gatedActionType,
  shopType,
  redirectTo,
  path,
  gated = false,
}: ClickedPromotionEventProps): TrackingEventResponse {
  return await trackEvent("Click Promotion", {
    props: {
      promo_id: id || name,
      promo_creative: creative,
      promo_position: position,
      promo_type: promotionType,
      promo_display_type: promoDisplayType?.toLowerCase(),
      promo_path: path,
      shop_type: shopType,
      redirect_to: redirectTo,
      gated_action_type: gatedActionType,

      tab,
      gated,
    },
    withRequestSource: true,
  });
}
